import {createActionTypes, createActionCreators} from 'utils/reduxUtils';

const typesArray = [
    'ADMIN_MOUNTING',
];

export const ActionTypes = createActionTypes(typesArray);
export const Actions = createActionCreators(typesArray);
